import { Categories } from "@/lib/models/header";

/**
 * Searches the category tree recursively to find a category node by its full path or slug.
 */
export function findCategoryByPath(
  nodes: Categories[],
  targetPath: string,
): Categories | null {
  if (!nodes || !Array.isArray(nodes) || !targetPath) return null;
  const normalized = targetPath.toLowerCase().trim();

  for (const node of nodes) {
    if (
      node.path?.toLowerCase().trim() === normalized ||
      node.slug?.toLowerCase().trim() === normalized
    ) {
      return node;
    }
    if (node.children && node.children.length > 0) {
      const found = findCategoryByPath(node.children, targetPath);
      if (found) return found;
    }
  }
  return null;
}

/**
 * Gets the display name for a category path from the loaded menu-tree,
 * with a fallback if the category node is not found.
 */
export function getCategoryDisplayName(
  categoriesMenu: Categories[],
  pathOrSlug: string,
  fallbackSlug?: string,
): string {
  const category = findCategoryByPath(categoriesMenu, pathOrSlug);
  if (category?.name) {
    return category.name;
  }
  const slugToFormat = fallbackSlug || pathOrSlug.split("/").pop() || pathOrSlug;
  return slugToFormat
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
